import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import { TbLicense } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';
import LicenseItem from './LicenseItem';
import { getLicenses } from '../../actions/license';

const LicenseList = ({ auth, getLicenses, license: { licenses, loading } }) => {
  useEffect(() => {
    getLicenses();
  }, [getLicenses]);

  const { t } = useTranslation();

  //Déclaration des hooks pour mettre à jour la liste des entités, la liste des droits et le tableau des utilisateurs.
  const [entitySelect, setEntitySelect] = useState('');
  const [stateSelect, setStateSelect] = useState('');
  const [typeSelect, setTypeSelect] = useState('');
  const [filteredLicenses, setFilteredLicense] = useState([]);

  //Récupéreration des licenses par rapport aux entités sélectionnées et aux droits sélectionnés.
  useEffect(() => {
    let filterLicense = licenses;
    //Si la valeur n'est pas vide, alors on prend la variable filterLicense et on filtre par rapport à l'entité sélectionnée, et on stocke la nouvelle liste dans la variable filterLicense.
    if (entitySelect !== '') {
      filterLicense = filterLicense.filter(
        (licence) => licence.entity === entitySelect
      );
    }

    //Si la valeur de stateSelect n'est pas vide, on filtre la licence.
    if (stateSelect !== '') {
      //Ici, on filtre la liste filterUser en vérifiant si stateSelect est égal à true. Si c'est le cas, cela retournera true ; cependant, si c'est false, cela nous renverra false car la condition n'est pas vérifiée.
      filterLicense = filterLicense.filter(
        (licence) => licence.status === stateSelect
      );
    }

    //Si la valeur de typeSelect n'est pas vide, on filtre la licence.
    if (typeSelect !== '') {
      //Ici, on filtre la liste filterUser en vérifiant si stateSelect est égal à true. Si c'est le cas, cela retournera true ; cependant, si c'est false, cela nous renverra false car la condition n'est pas vérifiée.
      filterLicense = filterLicense.filter(
        (licence) => licence.type === typeSelect
      );
    }

    //Ensuite, on renvoie la variable filterUser dans la fonction setFilteredUser.
    setFilteredLicense(filterLicense);
  }, [licenses, entitySelect, stateSelect, typeSelect]);

  //Récupération de la liste des entités et tri par ordre alphabéthique
  const listEntity = licenses
    .reduce(
      (acc, ent) => (acc.includes(ent.entity) ? acc : acc.concat(ent.entity)),
      []
    )
    .sort();

  //Récupération de la liste des status et tri par ordre alphabéthique
  const listStatus = licenses
    .reduce(
      (acc, licence) =>
        acc.includes(licence.status) ? acc : acc.concat(licence.status),
      []
    )
    .sort();

  //Récupération de la liste des droits et tri par ordre alphabéthique
  const listTypes = licenses
    .reduce(
      (acc, license) =>
        acc.includes(license.type) ? acc : acc.concat(license.type),
      []
    )
    .sort()
    .reverse();

  return (
    <section className="container">
      <Fragment>
        {loading || auth === null ? (
          <Spinner />
        ) : (
          <Fragment>
            {auth &&
            auth.user &&
            (auth.user.rights === 'admin' ||
              auth.user.rights === 'admin_entity' ||
              auth.user.rights === 'ADV') ? (
              <Fragment>
                <h1 className="large text-ascorel">{t('licenses')}</h1>
                <div className="parent-flex">
                  <p className="lead">
                    <TbLicense
                      size={40}
                      color="grey"
                      style={{
                        marginRight: '1rem'
                      }}
                    />
                    {t('license_lead')}
                  </p>
                  {auth &&
                  auth.user &&
                  (auth.user.rights === 'admin' ||
                    auth.user.rights === 'ADV') ? (
                    <div className="child-left-auto">
                      <Link to="/create-license">
                        <button
                          className="btn btn-ascorel btn-lg"
                          style={{ marginRight: '0rem', marginBottom: '1rem' }}
                        >
                          {t('license_create')}
                        </button>
                      </Link>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
                <table
                  className="table table-striped table-light table-header-group table-container"
                  // border="1"
                >
                  <thead>
                    <tr className="sticky">
                      <th
                        className="text-center align-middle"
                        id="th1"
                        colSpan="1"
                      >
                        {/* On crée un menu déroulant avec la valeur par défaut de la variable stateSelect. Si l'utilisateur change l'option du menu, la nouvelle valeur est ensuite assignée à la fonction setStateSelect. */}
                        <select
                          className="form-select form-select-sm"
                          value={stateSelect}
                          onChange={(e) => setStateSelect(e.target.value)}
                        >
                          {/* Première option qui renvoie une valeur vide */}
                          <option value="">
                            {t('license_state')}: {t('all_header')}
                          </option>
                          <Fragment>
                            {/* permet de de récupérer les différents status et de les afficher dans les options */}
                            {listStatus.map((nameStatus, index) => (
                              <option
                                value={nameStatus}
                                key={`${nameStatus}-${index}`}
                              >
                                {t('license_state')}:{' '}
                                {nameStatus === 'activated'
                                  ? t('activated')
                                  : nameStatus === 'disabled'
                                  ? t('deactivated')
                                  : nameStatus === 'finished'
                                  ? t('finished')
                                  : nameStatus === 'expired'
                                  ? t('expired')
                                  : t('deactivated')}
                              </option>
                            ))}
                          </Fragment>
                        </select>
                      </th>

                      <th
                        className="text-center align-middle hide-mobile"
                        id="th5"
                      >
                        {/* On met un menu de selection avec la valeur par défault de la variable de typeSelect, si le menu change d'option alors mettre la nouvelle valeur dans la fonction setTypeSelect */}
                        <select
                          className="form-select form-select-sm"
                          value={typeSelect}
                          onChange={(event) =>
                            setTypeSelect(event.target.value)
                          }
                        >
                          {/* première option qui affiche tout les types */}
                          <option value="" key="415">
                            {t('type_hint')}: {t('all_header')}
                          </option>
                          <Fragment>
                            {/* permet de de récupérer les différents types et de les afficher dans les options */}
                            {listTypes.map((type, index) => (
                              <option value={type} key={`${type}-${index}`}>
                                {t('type_hint')}: {type}
                              </option>
                            ))}
                          </Fragment>
                        </select>
                      </th>
                      <th className="text-center align-middle" id="th4">
                        {t('license')}
                      </th>
                      {auth.user.rights === 'admin' ||
                      auth.user.rights === 'ADV' ? (
                        <th className="text-center align-middle" id="th4">
                          {t('descriptionADV')}
                        </th>
                      ) : null}
                      <th
                        className="text-center align-middle hide-mobile"
                        id="th2"
                      >
                        {auth.user.rights === 'admin' ||
                        auth.user.rights === 'ADV'
                          ? t('descriptionAdminEntity')
                          : t('descriptionAdminEntity_viewcustomer')}
                      </th>
                      {auth.user.rights === 'admin' ||
                      auth.user.rights === 'ADV' ? (
                        <th
                          className="text-center align-middle hide-mobile"
                          id="th6"
                        >
                          {/* On met un menu de selection avec la valeur par défault de la variable de entitySelect, si le menu change d'option alors mettre la nouvelle valeur dans la fonction setEntitySelect */}
                          <select
                            className="form-select form-select-sm"
                            value={entitySelect}
                            onChange={(event) =>
                              setEntitySelect(event.target.value)
                            }
                          >
                            {/* première option qui affiche entity */}
                            <option value="" key="415">
                              {t('entity')}: {t('all_header')}
                            </option>
                            <Fragment>
                              {/* permet de de récupérer les différents entités et de les afficher dans les options */}
                              {listEntity.map((nameEntity, index) => (
                                <option
                                  value={nameEntity}
                                  key={`${nameEntity}-${index}`}
                                >
                                  {t('entity')}: {nameEntity}
                                </option>
                              ))}
                            </Fragment>
                          </select>
                        </th>
                      ) : null}
                      <th
                        className="text-center align-middle hide-mobile"
                        id="th7"
                      >
                        {t('startDate')}
                      </th>
                      <th
                        className="text-center align-middle hide-mobile"
                        id="th7"
                      >
                        {t('endDate')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* verifie que la longueur de la liste est supérieure a 0 */}
                    {filteredLicenses.length > 0 ? (
                      //Affichage des utilisateurs repondants aux criteres des select.
                      filteredLicenses.map((lice) => (
                        <LicenseItem
                          key={lice._id}
                          license={lice}
                          auth={auth}
                        />
                      ))
                    ) : (
                      // Si la liste est vide, afficher un message
                      <Fragment>
                        <tr>
                          <td className="text-center faq-title" colSpan="7">
                            {t('no_licenses_found')}
                          </td>
                        </tr>
                      </Fragment>
                    )}
                  </tbody>
                </table>
              </Fragment>
            ) : (
              <h4 className="large text-error">{t('unauthorized_access')}</h4>
            )}
          </Fragment>
        )}
      </Fragment>
    </section>
  );
};

LicenseList.propTypes = {
  getLicenses: PropTypes.func.isRequired,
  license: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  license: state.license,
  auth: state.auth
});

export default connect(mapStateToProps, { getLicenses })(LicenseList);
